module.exports = __webpack_public_path__ + "img/logo-error.a4a16ace.svg";